import script from "./Dormancy.vue?vue&type=script&setup=true&lang=js"
export * from "./Dormancy.vue?vue&type=script&setup=true&lang=js"

import "./Dormancy.vue?vue&type=style&index=0&id=8da46212&scope=true&lang=css"

const __exports__ = script;

export default __exports__